export const initialMasterData = {
    header: {
        title: "જલારામ વેજીટેબલ કું - ૨",
        subtitle: "ફ્રુટ - વેજીટેબલ મર્ચન્ટ અને કમિશન એજન્ટ",
        phone: "9824185221",
    },
    fields: [
        { label: "Opening Stock", id: "opening_stock", value: "", background: "#e1f5fe" },
        { label: "Box Code", id: "box_code", value: "", background: "#fff9c4" },
        { label: "Box Name Eng", id: "box_name_eng", value: "", background: "#c8e6c9" },
        { label: "Box Name Guj", id: "box_name_guj", value: "", background: "#ffecb3" },
    ],
    footerButtons: [
        { name: "AddNew", id: "add", disabled: false },
        { name: "Save", id: "save", disabled: true },
        { name: "Cancel", id: "cancel", disabled: false },
        { name: "Edit", id: "edit", disabled: true },
        { name: "Delete", id: "delete", disabled: true },
        { name: "Exit", id: "exit", disabled: false },
    ],
};
